<ng-container *ngIf="_selectedVariant">
  <span class="price void" *ngIf="_selectedVariant?.compare_at_price">
    {{ _selectedVariant.compare_at_price | currency }}
  </span>
  <span
    class="price"
    [ngClass]="
      _selectedVariant.compare_at_price &&
      _selectedVariant!.compare_at_price! > _selectedVariant!.price!
        ? 'sale'
        : ''
    "
  >
    {{ _selectedVariant.price | currency }}
  </span>
</ng-container>
